import {
  useGmailRedirectUrl,
  useOutlookRedirectUrl,
} from '@/hooks/actions/use-email-integration-actions';
import { PlatformEnum } from '@fluenceur/types';

/** The two mailbox providers a brand can connect. */
export type EmailConnectProvider = PlatformEnum.Gmail | PlatformEnum.Outlook;

/**
 * Shared "connect a mailbox" flow: resolves the provider's OAuth redirect URL
 * and navigates to it. Single source for every connect affordance
 * (EmailConnectPrompt's provider picker, the wizard's inline connect link), so
 * the redirect wiring never forks. `returnTo` brings the brand back to that path after OAuth.
 */
export const useEmailConnect = (returnTo?: string) => {
  const gmailRedirect = useGmailRedirectUrl(returnTo);
  const outlookRedirect = useOutlookRedirectUrl(returnTo);

  const connect = async (provider: EmailConnectProvider) => {
    const mutation = provider === PlatformEnum.Gmail ? gmailRedirect : outlookRedirect;
    const { redirectUrl } = await mutation.mutateAsync();
    window.location.href = redirectUrl;
  };

  return { connect, isConnecting: gmailRedirect.isPending || outlookRedirect.isPending };
};
